// Central brand + content data for Mark Clean Services Ltd

export const BUSINESS = {
  name: "Mark Clean Services Ltd",
  short: "Mark Clean",
  phone: "07958167002",
  phoneHref: "tel:+447958167002",
  email: "info@markcleanservices.co.uk",
  emailHref: "mailto:info@markcleanservices.co.uk",
  location: "Preston, Lancashire",
  whatsapp: "https://wa.me/447958167002",
  facebook: "https://facebook.com/markcleanservices",
  instagram: "https://instagram.com/markcleanservices",
  tiktok: "https://tiktok.com/@markcleanservices",
};

export const IMAGES = {
  heroInterior:
    "https://images.pexels.com/photos/7546322/pexels-photo-7546322.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cleanHome:
    "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODU3MTkyNzd8MA&ixlib=rb-4.1.0&q=85",
  carPolish:
    "https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  carWash:
    "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjB3YXNofGVufDB8fHx8MTc4NTcxOTI3N3ww&ixlib=rb-4.1.0&q=85",
  story:
    "https://images.pexels.com/photos/1125131/pexels-photo-1125131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Fully Insured", text: "Complete peace of mind on every visit." },
  { icon: "Smile", title: "Friendly & Reliable", text: "Consistent, trusted local professionals." },
  { icon: "Tag", title: "Affordable Prices", text: "Honest rates with no hidden fees." },
  { icon: "Truck", title: "Mobile Service", text: "We come to your home or driveway." },
  { icon: "BadgeCheck", title: "Satisfaction Guaranteed", text: "We're not happy until you are." },
  { icon: "UserCheck", title: "DBS Checked", text: "Vetted staff you can welcome inside." },
];

export const DOMESTIC_SERVICES = [
  "Weekly Cleaning",
  "Fortnightly Cleaning",
  "One-Off Cleaning",
  "Deep Cleaning",
  "End of Tenancy Cleaning",
  "Move In Cleaning",
  "Ironing",
  "Kitchen Cleaning",
  "Bathroom Cleaning",
];

export const DOMESTIC_INCLUDED = [
  "Vacuuming",
  "Dusting",
  "Mopping",
  "Kitchen Cleaning",
  "Bathroom Cleaning",
  "Bedrooms",
  "Living Areas",
  "General Tidying",
];

export const VALET_PACKAGES = [
  {
    tier: "Bronze",
    name: "Bronze Wash",
    price: "£25",
    blurb: "A crisp exterior refresh.",
    features: ["Exterior hand wash", "Wheels & tyres", "Windows cleaned", "Hand dried"],
  },
  {
    tier: "Silver",
    name: "Silver Mini Valet",
    price: "£40",
    blurb: "Inside & out essentials.",
    features: ["Everything in Bronze", "Interior vacuum", "Dashboard wipe down", "Door shuts cleaned"],
  },
  {
    tier: "Gold",
    name: "Gold Full Valet",
    price: "£70",
    blurb: "Our most popular detail.",
    features: ["Everything in Silver", "Full interior clean", "Leather / trim care", "Tyre dressing & wax"],
    popular: true,
  },
  {
    tier: "Platinum",
    name: "Platinum Deep Valet",
    price: "£110",
    blurb: "A showroom-level transformation.",
    features: ["Everything in Gold", "Deep interior shampoo", "Paint decontamination", "Premium protective wax"],
  },
];

export const VALET_EXTRAS = [
  "Seat Shampoo",
  "Engine Bay",
  "Pet Hair Removal",
  "Machine Polish (future)",
  "Ceramic Coating (future)",
];

export const DOMESTIC_PRICES = [
  { service: "Weekly Cleaning", price: "from £15 / hour" },
  { service: "Fortnightly Cleaning", price: "from £16 / hour" },
  { service: "One-Off Cleaning", price: "from £18 / hour" },
  { service: "Deep Cleaning", price: "from £20 / hour" },
  { service: "End of Tenancy Cleaning", price: "from £120" },
  { service: "Ironing", price: "from £14 / hour" },
];

export const VALET_PRICES = [
  { service: "Bronze Wash", price: "£25" },
  { service: "Silver Mini Valet", price: "£40" },
  { service: "Gold Full Valet", price: "£70" },
  { service: "Platinum Deep Valet", price: "£110" },
];

export const REVIEWS = [
  { text: "Fantastic service. My home has never looked cleaner.", author: "Sarah", place: "Preston" },
  { text: "Excellent car valet. Very professional.", author: "James", place: "Fulwood" },
  { text: "Reliable, friendly and always thorough. Highly recommend.", author: "Emma", place: "Penwortham" },
  { text: "Booked a deep clean before moving in — spotless from top to bottom.", author: "David", place: "Leyland" },
];

export const AREAS = [
  "Preston",
  "Fulwood",
  "Penwortham",
  "Bamber Bridge",
  "Leyland",
  "Chorley",
  "Longridge",
  "Blackburn",
];

export const VALUES = [
  "Professionalism",
  "Reliability",
  "Honesty",
  "Quality",
  "Customer Satisfaction",
];

export const SERVICE_OPTIONS = [  "Weekly Cleaning",
  "Fortnightly Cleaning",
  "One-Off Cleaning",
  "Deep Cleaning",
  "End of Tenancy Cleaning",
  "Ironing",
  "Bronze Wash (£25)",
  "Silver Mini Valet (£40)",
  "Gold Full Valet (£70)",
  "Platinum Deep Valet (£110)",
  "Other / Not Sure",
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Cleaning", caption: "Spotless kitchen deep clean" },
  { url: "https://images.pexels.com/photos/6873085/pexels-photo-6873085.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Valeting", caption: "Gloss finish exterior detail" },
  { url: "https://images.pexels.com/photos/4239146/pexels-photo-4239146.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Cleaning", caption: "Bathroom sanitised & shining" },
  { url: "https://images.pexels.com/photos/3354648/pexels-photo-3354648.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Valeting", caption: "Interior valet, showroom fresh" },
  { url: "https://images.pexels.com/photos/6195122/pexels-photo-6195122.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Cleaning", caption: "End of tenancy transformation" },
  { url: "https://images.pexels.com/photos/5233273/pexels-photo-5233273.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Valeting", caption: "Wheels & tyres detailed" },
  { url: "https://images.pexels.com/photos/4098778/pexels-photo-4098778.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Cleaning", caption: "Living space refresh" },
  { url: "https://images.pexels.com/photos/372810/pexels-photo-372810.jpeg?auto=compress&cs=tinysrgb&w=940", cat: "Valeting", caption: "Full valet, mirror shine" },
];

// Before / after comparison pairs
export const BEFORE_AFTER = [
  {
    title: "Deep Kitchen Clean",
    tag: "Domestic Cleaning",
    before: "https://images.pexels.com/photos/4239013/pexels-photo-4239013.jpeg?auto=compress&cs=tinysrgb&w=940",
    after: "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODU3MTkyNzd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Full Exterior Valet",
    tag: "Mobile Car Valeting",
    before: "https://images.pexels.com/photos/3806288/pexels-photo-3806288.jpeg?auto=compress&cs=tinysrgb&w=940",
    after: "https://images.pexels.com/photos/6873085/pexels-photo-6873085.jpeg?auto=compress&cs=tinysrgb&w=940",
  },
];
